import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { Loader2, Lock } from 'lucide-react'
import { ROUTES } from '@/constants'
import { getAuth0AuthorizationParams } from '@/lib/auth0Config'

export function LoginForm() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading) return

    if (isAuthenticated) {
      navigate(ROUTES.HOME, { replace: true })
    } else {
      void loginWithRedirect({
        appState: { returnTo: ROUTES.HOME },
        authorizationParams: getAuth0AuthorizationParams(),
      })
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, navigate])

  return (
    <div className="flex flex-col items-center justify-center py-10 gap-3">
      <Loader2 size={22} className="animate-spin text-brand-600" />
      <span className="text-sm text-text-tertiary">
        {isLoading ? 'Verificando sesión...' : 'Redirigiendo al inicio de sesión...'}
      </span>
      <div className="flex items-center gap-1.5 pt-2">
        <Lock size={11} className="text-text-quaternary" />
        <span className="text-xs text-text-quaternary">Conexión segura con Auth0</span>
      </div>
    </div>
  )
}
